import React from "react";
import { Outlet } from "react-router-dom";

const MobileSettingsWrapper: React.FC = () => <Outlet />;

export default MobileSettingsWrapper;
